import numeral from 'numeral'
import PropTypes from 'prop-types'
import React from 'react'

import { getFromFee, isNltBrumbrum } from '../../../utils/nltUtils'
import BuyPricePromozione from '../../buy/dumb/BuyPricePromozione'
import { filesBaseUrl } from '../../buy/utils'
import CouponConfig from '../../common/CouponConfig'
import formatCilindrata from '../formatCilindrata'

const MiniCartNlt = ({
  centroConvenzionatoNome,
  isFreePrice,
  numberOrText,
  prezzoLogistica,
  prezzoLogisticaPromozione,
  product,
  nlt,
  ui,
}) => {
  numeral.language('it')

  return (
    <div className="carbox__item" id="miniCartNlt">
      <div className="carbox__image">
        <img
          src={`${filesBaseUrl}/pictures/${product.id_auto}/close.27.mid.jpg`}
        />
      </div>
      <div className="carbox__info">
        <div className="carbox__title minicart-title">
          <h4>
            <span className="brand">{product.marca}</span>
            {product.modello === product.marca ? (
              <span className="brand"> {product.allestimento_breve}</span>
            ) : (
              <span className="brand"> {product.modello}</span>
            )}
          </h4>

          <span className="minicart-det">{product.allestimento_breve}</span>
          <span className="minicart-det">
            &nbsp;|&nbsp;
            {`${formatCilindrata(product.cilindrata)} ${product.alimentazione}`}
          </span>
          <span className="minicart-det"> |&nbsp;{product.potenza} CV</span>

          <br />

          <span className="minicart-det">
            {product.cambio} |&nbsp;
            <span className="nlt-nuovo">Nuovo</span>
            {nlt.selectedCanone &&
            nlt.selectedCanone.anticipo !== null &&
            !isNltBrumbrum(product) ? (
              <span className="minicart-100k">
                {' '}
                |&nbsp;
                {numeral(nlt.selectedCanone.km_inclusi).format('0[,]00')} Km
                inclusi
              </span>
            ) : null}
          </span>
        </div>
        {nlt.selectedCanone && nlt.selectedCanone.anticipo !== null && (
          <div className="row">
            <div className="left">Anticipo</div>
            <div className="right">
              <span>
                € {numeral(nlt.selectedCanone.anticipo).format('0[,]00')} (IVA
                incl.)
              </span>
            </div>
          </div>
        )}
        {nlt.selectedCanone && nlt.selectedCanone.numero_mensilita && (
          <div className="row">
            <div className="left">Durata</div>
            <div className="right">
              <span>{nlt.selectedCanone.numero_mensilita} mesi</span>
            </div>
          </div>
        )}
        {nlt.selectedCanone &&
          nlt.selectedCanone.numero_mensilita &&
          nlt.selectedCanone.km_inclusi &&
          isNltBrumbrum(product) && (
            <div className="row">
              <div className="left">Chilometri inclusi</div>
              <div className="right">
                <span>
                  {numeral(
                    nlt.selectedCanone.km_inclusi *
                      (nlt.selectedCanone.numero_mensilita / 12)
                  ).format('0[,]00')}{' '}
                  (max {numeral(nlt.selectedCanone.km_inclusi).format('0[,]00')}
                  /anno)
                </span>
              </div>
            </div>
          )}

        {nlt.selectedCanone &&
        nlt.selectedCanone.km_inclusi &&
        !isNltBrumbrum(product) ? (
          <div className="row">
            <div className="left">Chilometri inclusi</div>
            <div className="right">
              <span>
                {numeral(nlt.selectedCanone.km_inclusi).format('0[,]00')} km
              </span>
            </div>
          </div>
        ) : null}

        {(nlt.serviziPlusSelected.length > 0 || isNltBrumbrum(product)) &&
          nlt.selectedCanone &&
          nlt.selectedCanone.canone_mensile && (
            <div
              className={`row canoneBase ${
                isNltBrumbrum(product) ? 'gray' : ''
              }`}
            >
              <div className="left">
                <ul>
                  <li>
                    {isNltBrumbrum(product) ? 'Canone mensile' : 'Canone base'}
                  </li>
                </ul>
              </div>
              <div className="right">
                <span>
                  <span
                    className={`${
                      isNltBrumbrum(product) ? 'text-grey800' : ''
                    }`}
                  >
                    €{' '}
                    {getFromFee('canone_mensile', nlt.selectedCanone, {
                      addCapKm: isNltBrumbrum(product),
                    })}
                  </span>
                  /mese (IVA incl.)
                </span>
              </div>
            </div>
          )}

        {nlt.selectedCanone &&
          nlt.selectedCanone.fee_km &&
          !isNltBrumbrum(product) && (
            <div className="row gray">
              <div className="left">Costo chilometrico</div>
              <div className="right">
                <span>
                  <span className="text-grey800">
                    € {numeral(nlt.selectedCanone.fee_km).format('0[.]00')}
                  </span>
                  /km (IVA incl.)
                </span>
              </div>
            </div>
          )}

        {isNltBrumbrum(product) && (
          <div className="row gray">
            <div className="left">Canone minimo</div>
            <div className="right">
              <span className="text-grey800">
                €
                {numeral(
                  getFromFee('canone_mensile', nlt.selectedCanone)
                ).format()}
              </span>
              /mese (IVA incl.)
            </div>
            <br style={{ clear: 'both' }} />
            <div style={{ display: 'block' }}>
              <p style={{ fontSize: '13px' }}>
                Con l'offerta brumbrum se guidi poco spendi meno e per
                quest'auto puoi risparmiare fino a €
                {numeral(nlt.selectedCanone.cap_variabile_kilometrico).format(
                  '0[,]00'
                )}
                . Ogni chilometro percorso ha un costo di €
                {numeral(nlt.selectedCanone.fee_km).format('0[.]00')}
              </p>
            </div>
          </div>
        )}

        {nlt.serviziPlusSelected.length > 0 && (
          <div className="row">
            <div className="left">
              Servizi plus
              <ul id="serviziPlusSelected">
                {nlt.serviziPlusSelected.map(servizioPlusIdTipologia => {
                  const servizioPlus =
                    nlt.serviziPlusByIdTipologia[servizioPlusIdTipologia]
                  return (
                    <li key={servizioPlusIdTipologia}>
                      {servizioPlus.tipologia}
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className="right">
              <span>€ {nlt.serviziPlusCosto}/mese (IVA incl.)</span>
            </div>
          </div>
        )}

        {nlt.canonePersonalizzato && (
          <div className="row">
            <div className="left">
              <span>
                {nlt.minicartLabelCanonePersonalizzato ||
                  nlt.minicartLabel ||
                  'Codice Preventivo'}
              </span>
            </div>
            <div className="right">
              <span>{nlt.canonePersonalizzato}</span>
            </div>
          </div>
        )}
        {nlt.codiceCoupon && (
          <div className="row">
            <div className="left">
              <span>{nlt.minicartLabelCoupon}</span>
            </div>
            <div className="right">
              <span>{nlt.codiceCoupon}</span>
            </div>
            <CouponConfig
              couponCode={nlt.codiceCoupon}
              selloutSettings={ui.sellout_settings_noleggia}
            />
          </div>
        )}

        {centroConvenzionatoNome &&
          prezzoLogistica &&
          isNltBrumbrum(product) && (
            <div className="row prezzo-logistica">
              <div className="left">
                Consegna:{' '}
                <span className="citta-scelta">{centroConvenzionatoNome}</span>
              </div>
              <div className="right">
                <BuyPricePromozione
                  isFreePrice={isFreePrice}
                  numberOrText={numberOrText}
                  prezzoLogistica={
                    prezzoLogistica === 'Incluso'
                      ? 'In regalo'
                      : prezzoLogistica
                  }
                  prezzoLogisticaPromozione={prezzoLogisticaPromozione}
                />{' '}
                {prezzoLogistica !== 'Incluso' ? '(Iva incl.)' : null}
              </div>
            </div>
          )}

        {nlt.selectedCanone &&
        nlt.selectedCanone.canone_mensile &&
        !isNltBrumbrum(product) ? (
          <div className="row last foot gray calculate-total">
            <div className="left">Canone totale</div>
            <div className="right">
              <b>
                <span className="paragraph text-grey800">
                  €
                  <span className="subtitle text-grey800">
                    {' '}
                    {getFromFee('canone_mensile', nlt.selectedCanone, {
                      plusServicesCost: nlt.serviziPlusCosto,
                    })}
                  </span>
                </span>
              </b>
              /mese (IVA incl.)
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

MiniCartNlt.propTypes = {
  product: PropTypes.object,
  nlt: PropTypes.object,
}

MiniCartNlt.defaultProps = {
  product: {},
  nlt: {},
}

export default MiniCartNlt
